import React from "react";
import RaterNavbar from "../../modules/rater/RaterNavbar";
import RaterQuestion from "./RaterQuestion";

const RaterExamRoomQuestion = () => {

  return (
    <>
      <RaterNavbar />
      <RaterQuestion />
    </>
  )
};

export default RaterExamRoomQuestion;
